import React from "react";
import PageHeader from "../components/PageHeader";
import Card from "../components/Card";

export default function AboutTab() {
  return (
    <>
      <PageHeader
        title="About This Songbook"
        description="A labor of love for Dad — Bob Dylan’s albums in order, our favorite lines, and the meanings they carry."
      />
      <Card className="lg">
        <p className="sm" style={{ marginTop: 0 }}>
          We organize by album, separated by year, chronologically. Open an
          album, then a song, and capture favorite lines with notes and comment
          threads, like the scribbles in a well-loved notebook.
        </p>
        <p className="xs muted">
          We avoid showing full lyrics; instead we store short snippets to
          anchor our memories.
        </p>
      </Card>
    </>
  );
}
